export const checksums = {
  "articles": "v3.5.0--ThY0xkQGB8WcKHUDPaPxG7ib-YxVuF7o07MjCGX0ZDs",
  "videos": "v3.5.0--6DFMIulqq5tTzOe27pJOr3EFYv3meRMtTGNxdFui1XI",
  "podcasts": "v3.5.0--Qf-UyU2wXCl0Uyx6y4qs-52EHcNzdm2eWmxe49b2YCA",
  "landing": "v3.5.0--yVrfzPQG38gTvLV9cEQFXLyKrP3DMNXe34Tq96yfQSE",
  "testimonials": "v3.5.0--nezyVxl2SSyc6SIE_S0mwyRbWJ-_jtyMk6xQ-oFAmmU"
}
export const checksumsStructure = {
  "articles": "ozJg2VNo2yEEPfwuzwtAPAwHm94ANVY9OYXIa1wGH5g",
  "videos": "ytUF-Tfmpq1n8ZQ0OShMgRZeffWt-exsshRekLU-MGM",
  "podcasts": "TV7Kwe6R6Yfu7Wducdq0XTOvWLiSE_5ZC5jfKyIkJFw",
  "landing": "WKHB3BcNLj4ShLgZHLU8UyYIf7iR5pjIkj5OhGjpyJQ",
  "testimonials": "7nLR5vooAvI6WJvHsIWzxKY3-IMOtcKXDupiJmG94F4"
}

export const tables = {
  "articles": "_content_articles",
  "videos": "_content_videos",
  "podcasts": "_content_podcasts",
  "landing": "_content_landing",
  "testimonials": "_content_testimonials",
  "info": "_content_info"
}

export default {
  "articles": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "badge": "json",
      "body": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "head": "json",
      "image": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "sitemap": "json",
      "stem": "string"
    }
  },
  "videos": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "badge": "string",
      "body": "json",
      "createdAt": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "podcasts": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "badge": "string",
      "body": "json",
      "createdAt": "string",
      "date": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "string",
      "description": "string",
      "extension": "string",
      "features": "string",
      "hero": "string",
      "logos": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "planComparison": "string",
      "pricing": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "testimonials": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "author": "string",
      "badge": "string",
      "createdAt": "string",
      "description": "string",
      "extension": "string",
      "image": "json",
      "mediaType": "string",
      "mediaUrl": "string",
      "meta": "json",
      "stem": "string",
      "subheading": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}